import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TwoFaGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    // Sin sesión -> login
    if (!currentUser || !currentUser.token) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // Con 2FA activo -> permitir acceso
    if (currentUser.user && currentUser.user.has_2fa === true) {
      return true;
    }

    // Sesión activa pero sin 2FA -> obligar configuración
    this.router.navigate(['/auth/setup-2fa']);
    return false;
  }
}
